class NoDataError extends Error {}

export { NoDataError }
